import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";

export default function Layout() {
  return (
    <div className="grain relative min-h-screen flex flex-col bg-[#050505] text-white">
      <Header />
      <main className="flex-1 pt-20 relative z-[2]">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
